import { Config } from '#lib/constants/config.js';
import {
	HENI_ORGANIZATION_ID,
	HENI_ORGANIZATION_REF,
	HENI_SAME_AS,
} from '#lib/features/seo/constants/heni-organization.js';

export const getHomepageJsonLd = () => ({
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'Organization',
			'@id': HENI_ORGANIZATION_ID,
			name: 'HENI',
			url: Config.Domain,
			logo: {
				'@type': 'ImageObject',
				url: `${Config.Domain}/img-svelte/heni-logo-large.jpg`,
				width: 2048,
				height: 2048,
			},
			sameAs: HENI_SAME_AS,
			description:
				'HENI is a technology company pioneering art markets and information, working with world-leading artists and estates.',
		},
		{
			'@type': 'WebSite',
			'@id': `${Config.Domain}#website`,
			name: 'HENI',
			url: Config.Domain,
			publisher: HENI_ORGANIZATION_REF,
		},
	],
});
